// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3N1aC","right":"Footer_right__2vGlx","buttons":"Footer_buttons__3rfF6"};